import React, {Component} from 'react';
import Route from 'react-router-dom/Route';
import { Helmet } from "react-helmet";

import IndexPage from './pages/Index';
import ShowPage from './pages/Show';

import Store from './Store'

const store = new Store();

const renderMergedProps = (component, ...rest) => {
    const finalProps = Object.assign({}, ...rest);
    return (
        React.createElement(component, finalProps)
    );
};

const PropsRoute = ({ component, ...rest }) => {
    return (
        <Route {...rest} render={routeProps => {
            return renderMergedProps(component, routeProps, rest);
        }}/>
    );
};

export default class People extends Component {
    render() {
        return (
            <main>
                <Helmet titleTemplate="%s | Prelegenci | Gamedev.js" defaultTitle="Prelegenci | Gamedev.js" />

                <PropsRoute key="index" exact path={this.props.match.url} store={store} component={IndexPage}/>
                <PropsRoute key="show" path={this.props.match.url + '/:slug'} store={store} component={ShowPage}/>
            </main>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/People/Module.js